export default "__VITE_ASSET__DlXRdhpi__"